import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

function Register({ onLogin }) {
  const { referralCode } = useParams();
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    confirmPassword: '',
    network_company_id: '',
    referral_code: referralCode || ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isCodeLocked, setIsCodeLocked] = useState(!!referralCode);

  useEffect(() => {
    if (referralCode) {
      setFormData(prev => ({
        ...prev,
        referral_code: referralCode
      }));
      setIsCodeLocked(true);
    }
  }, [referralCode]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Validate passwords match
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      setLoading(false);
      return;
    }

    try {
      const requestData = {
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        password: formData.password,
        network_company_id: formData.network_company_id || null,
        referral_code: formData.referral_code
      };
      
      console.log('Sending registration data:', requestData);
      
      const response = await fetch('/backend/api/auth/register.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(requestData)
      });

      let data;
      try {
        data = await response.json();
      } catch (jsonError) {
        console.error('Failed to parse response:', jsonError);
        setError('Server error. Please try again.');
        setLoading(false);
        return;
      }

      if (response.ok) {
        onLogin(data.user);
      } else {
        setError(data.error || 'Registration failed');
      }
    } catch (error) {
      console.error('Network error:', error);
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: '50px auto', padding: '20px' }}>
      <h2>Register for MasterTask</h2>
      
      {error && (
        <div style={{ color: 'red', marginBottom: '20px' }}>
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <label>First Name:</label>
          <input
            type="text"
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label>Last Name:</label>
          <input
            type="text"
            name="last_name"
            value={formData.last_name}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label>Email:</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
          />
        </div>

            <div style={{ marginBottom: '15px' }}>
              <label>Network ID *:</label>
              <input
                type="text"
                name="network_company_id"
                value={formData.network_company_id}
                onChange={handleChange}
                placeholder="e.g., 10891"
                required
                style={{ width: '100%', padding: '8px', marginTop: '5px' }}
              />
              <small style={{ color: '#666', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                Enter your personal network ID from your MLM company
              </small>
            </div>

        <div style={{ marginBottom: '15px' }}>
          <label>Referral Code *:</label>
          <input
            type="text"
            name="referral_code"
            value={formData.referral_code}
            onChange={handleChange}
            placeholder="e.g., JK-12345"
            required
            disabled={isCodeLocked}
            style={{ 
              width: '100%', 
              padding: '8px', 
              marginTop: '5px',
              backgroundColor: isCodeLocked ? '#f0f0f0' : 'white',
              cursor: isCodeLocked ? 'not-allowed' : 'text'
            }}
          />
          <small style={{ color: isCodeLocked ? '#10b981' : '#666', fontSize: '12px', marginTop: '4px', display: 'block' }}>
            {isCodeLocked ? '✓ Referral code locked from invite link' : 'Get this code from your mentor who invited you'}
          </small>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label>Password:</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            minLength="8"
            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label>Confirm Password:</label>
          <input
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
          />
        </div>

        <button 
          type="submit" 
          disabled={loading}
          style={{ 
            width: '100%', 
            padding: '10px', 
            backgroundColor: '#28a745', 
            color: 'white', 
            border: 'none',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? 'Creating Account...' : 'Register'}
        </button>
      </form>

      <p style={{ textAlign: 'center', marginTop: '20px' }}>
        Already have an account? <Link to="/login">Login here</Link>
      </p>
    </div>
  );
}

export default Register;
